/*----------------------------------
- CATALOG (SSOT): THE WORLD FOOTER'S COPY
----------------------------------*/

/**
 * The words of the world footer's sky (the mock's `footer.world.wf .wf-sky > .wf-cta`, the night launch of docs/mockups/website-page-template.html)
 * and of its bottom bar. The figures are never here: the domains count and the members count are server fields a page
 * passes (`stats.totalDomains`, `stats.totalSignups`), and the plan line reads `PUBLIC_PLAN_FACTS` and the refund promise
 * through `HOME_FINAL_CTA_COPY.reassurance`.
 *
 * @docs docs/features/website-navigation-shell
 * @rule The two persona cards sit under the sky on every page (the page template, mock parity F2, letter E21 A of
 *       2026-11-04), so the sub names the choice everywhere; Home keeps its frozen ids (`Footer homeClosing`).
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { HOME_FINAL_CTA_COPY } from '@/client/catalogs/landing/pageContent';

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const WORLD_FOOTER_COPY = {
    /** After the formatted count ("32.2 million"), or after the fallback when no count was sent. */
    headlineLead: HOME_FINAL_CTA_COPY.headlineLead,
    headlineCountFallback: HOME_FINAL_CTA_COPY.headlineCountFallback,
    headlineFollowUp: HOME_FINAL_CTA_COPY.headlineFollowUp,
    /** The two persona cards follow it on every page: the choice the cards offer leads the line. */
    sub: 'Pick how you hunt. Your first search comes back in about two minutes, every name with its price, demand, history and trademark risk.',
    /** The words after the members count (`ProofLine`). */
    proofLabel: 'founders and investors have joined',
    reassurance: HOME_FINAL_CTA_COPY.reassurance,
    signInLabel: HOME_FINAL_CTA_COPY.alreadyMemberCtaLabel,
    tagline: 'Where domain decisions are made.',
    companyName: 'Unique Domains',
} as const;
